module.exports = __webpack_public_path__ + "img/step2-c.ac631a42.png";